import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css'],
  standalone: false
})
export class RedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // créé juste pour les redirections ou refresh url
  }

}
